import { useContext, useMemo } from "react";
import { CalculatorContext } from "../state/calculatorContext";
import { ACTION_TYPES } from "../state/actionTypes";

export const useCalculatorStore = () => {
  const context = useContext(CalculatorContext);
  if (!context) {
    throw new Error("useCalculatorStore must be used within a CalculatorProvider");
  }

  const { state, dispatch } = context;

  // React guarantees dispatch from useReducer is stable across renders.
  const actions = useMemo(
    () => ({
      setInitialData: (data) => dispatch({ type: ACTION_TYPES.SET_INITIAL_DATA, payload: data }),
      setSelectedQuery: (query) => dispatch({ type: ACTION_TYPES.SET_SELECTED_QUERY, payload: query }),
      setPortOperations: (ports) => dispatch({ type: ACTION_TYPES.SET_PORT_OPERATIONS, payload: ports }),
      updatePortOperation: (payload) => dispatch({ type: ACTION_TYPES.UPDATE_PORT_OPERATION, payload }),
      reorderPortOperations: (oldIndex, newIndex) =>
        dispatch({ type: ACTION_TYPES.REORDER_PORT_OPERATIONS, payload: { oldIndex, newIndex } }),
      addPortOperation: (port) => dispatch({ type: ACTION_TYPES.ADD_PORT_OPERATION, payload: port }),
      deletePortOperation: (index) => dispatch({ type: ACTION_TYPES.DELETE_PORT_OPERATION, payload: index }),
      setFleetList: (fleets) => dispatch({ type: ACTION_TYPES.SET_FLEET_LIST, payload: fleets }),
      setSelectedVessel: (vessel) => dispatch({ type: ACTION_TYPES.SET_SELECTED_VESSEL, payload: vessel }),
      setPortDistances: (distances) => dispatch({ type: ACTION_TYPES.SET_PORT_DISTANCES, payload: distances }),
      setCalculationResult: (result) => dispatch({ type: ACTION_TYPES.SET_CALCULATION_RESULT, payload: result }),
      setLoading: (loading, message = "") => dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { loading, message } }),
      setError: (error) => dispatch({ type: ACTION_TYPES.SET_ERROR, payload: error }),
      setIsOverride: (isOverride) => dispatch({ type: ACTION_TYPES.SET_IS_OVERRIDE, payload: isOverride }),
      resetState: () => dispatch({ type: ACTION_TYPES.RESET_STATE }),
    }),
    [dispatch]
  );

  return {
    state,
    dispatch,
    ...actions,
  };
};
